export default class SummaryPrintHelper {
    setup() {

        const printButton = document.querySelector(
            '[data-print-summary-button]'
        );

        document.addEventListener('DOMContentLoaded', () => {
            if (printButton) {
                this.summaryWrapperAddedListener(printButton);
            }
        });
    }

    summaryWrapperAddedListener(printButton) {
        const printUrl = printButton.getAttribute(
            'data-print-summary-url'
        );
        const printIframe = document.getElementById('printIframe');

        if (printButton) {
            printButton.addEventListener('click', function () {
                printIframe.src = printUrl;
            });
        }

        // This summaryWrapperAdded event is triggered when the summary wrapper is added to the print child iframe
        // It's dispatched in /www/wp-content/themes/vardanalys/digital-publications/src/scripts/SummaryPrintHelper.js
        window.parent.document.addEventListener(
            'summaryWrapperAdded', event => {
            if (event.detail.selector === '.summary-wrapper') {
                if (printIframe.src) {
                    printIframe.contentWindow.print();
                }
            }
        });
    }
}